export const CLEAR_DRAGGING_SOURCE = 'CLEAR_DRAGGING_SOURCE';
export const CLEAR_DRAGGING_TARGET = 'CLEAR_DRAGGING_TARGET';
export const DRAG_END = 'DRAG_END';
export const DRAG_START = 'DRAG_START';
export const DROP = 'DROP';
export const MOVE_TO_POSITION = 'MOVE_TO_POSITION';
export const RESET = 'RESET';
export const SET_CLONE = 'SET_CLONE';
export const SET_DRAGGING_SOURCE = 'SET_DRAGGING_SOURCE';
export const SET_DRAGGING_TARGET = 'SET_DRAGGING_TARGET';
